import RegistrationYearFilter from "./RegistrationYearFilter"

export default  RegistrationYearFilter;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/RegistrationYearFilter/index.js